import { atom } from "recoil";
import { IContact } from "../types/Contact";

export const ContactCRMAtom = atom<IContact | null>({
  key: "ContactCRMAtom",
  default: null,
});
